import React, { useEffect, useState } from "react";
import * as adminApi from "../../../service/adminApi";
import { useNavigate } from "react-router-dom";
import { RedirectCode400 } from "../../RedirectCode400";
import { CurrentUserContext } from "../../../App";
import { useContext } from "react";
import PageHeaderV2 from "../../pageheaderV2/PageHeaderV2";
import { FaTrash, FaEdit } from "react-icons/fa";
import format from "date-fns/format";
import TableSearchV1 from "../../tableV1/tableSearchV1";

function HospitalSetting() {
  const { setIsMessage } = useContext(CurrentUserContext);

  const navigate = useNavigate();

  const [dataHospital, setDataHospital] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showList, setShowList] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [totalPage, setTotalPage] = useState(1);
  const [filters, setFilters] = useState({
    hospital_name: "",
    "create_date.date": "",
    "update_date.date": "",
  });
  const [sortBy, setSortBy] = useState({ id: "", desc: false });

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    getHospital();
  }, [page, filters, sortBy]);

  const getHospital = async () => {
    setIsLoading(true);
    let res = await adminApi.getHospital(
      page,
      10,
      filters.hospital_name,
      formatDate(filters["create_date.date"]),
      formatDate(filters["update_date.date"]),
      sortBy.id,
      sortBy.id ? (sortBy.desc ? "desc" : "asc") : "",
    );
    setIsLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setDataHospital(res["data"]["webhook_list"]);
        setTotal(res["data"]["amount"]);
        setTotalPage(Math.ceil(res.data?.webhook_list?.length / 10));
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const formatDate = (date) => {
    if (!date) return "";
    return format(date, "yyyy-MM-dd");
  };

  const formatDateThai = (date) => {
    const monthsThai = [
      "ม.ค.",
      "ก.พ.",
      "มี.ค.",
      "เม.ย.",
      "พ.ค.",
      "มิ.ย.",
      "ก.ค.",
      "ส.ค.",
      "ก.ย.",
      "ต.ค.",
      "พ.ย.",
      "ธ.ค.",
    ];
    const [year, month, day] = date.split("-");
    const formattedDate = `${parseInt(day)} ${
      monthsThai[parseInt(month) - 1]
    } ${year}`;
    return formattedDate;
  };

  const handleSortChange = (id, desc) => {
    setPage(1);
    setSortBy({ id, desc });
  };

  const removeWebBook = async (item) => {
    if (!window.confirm(`คุณต้องการลบ ${item["hospital_name"]} ใช่หรือไม่`)) {
      return;
    }
    let res = await adminApi.removeWebHook(item["webhook_id"]);
    if (res) {
      if (res["data"]["code"] === 200) {
        getHospital();
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
      setDataHospital([]);
    }
  };

  const columns = [
    {
      Header: "No.",
      accessor: "id",
      Filter: "#",
    },
    {
      Header: "ชื่อโรงพยาบาล/ หน่วยงาน",
      accessor: "hospital_name",
      Filter: "text",
    },
    {
      Header: "วันที่ทำรายการ",
      accessor: "create_date.date",
      Cell: ({ row }) => {
        const createdDate =
          row.original.create_date && row.original.create_date.date
            ? row.original.create_date.date
            : null;
        return createdDate ? formatDateThai(createdDate) : "";
      },
      Filter: "date",
    },
    {
      Header: "วันที่แก้ไขรายการ",
      accessor: "update_date.date",
      Cell: ({ row }) => {
        const createdDate =
          row.original.update_date && row.original.update_date.date
            ? row.original.update_date.date
            : null;
        return createdDate ? formatDateThai(createdDate) : "";
      },
      Filter: "date",
    },
    {
      Header: "#",
      disableSortBy: true,
      accessor: "actions",
      Cell: ({ row }) => {
        const i = row.original;

        return (
          <div className="flex flex-row justify-center items-center gap-[6px]">
            <div
              className="flex justify-center items-center h-[30px] p-2 rounded-[5px] cursor-pointer"
              style={{ background: "#AFEBE3 0% 0% no-repeat padding-box" }}
              onClick={() => {
                navigate("/admin/hospitalsetting/edit-hospital", {
                  state: {
                    mode: "edit",
                    id: i["webhook_id"],
                    hospital_id: i["hospital_id"],
                    hospital_name: i["hospital_name"],
                    ip_address: i["ip_address"],
                    client_id: i["client_id"],
                    client_secret: i["client_secret"],
                    // revoke: i["revoke"],
                    // send: i["send"],
                  },
                });
              }}
            >
              <FaEdit className="text-[#00917E] h-[14px]" />
            </div>
            <div className="flex flex-row justify-center items-center gap-[6px]">
              <button
                className="flex justify-center items-center h-[30px] p-2 rounded-[5px] cursor-pointer"
                style={{ background: "#FCD8DB 0% 0% no-repeat padding-box" }}
                onClick={() => removeWebBook(i)}
              >
                <FaTrash className="text-[#D32736] h-[14px]" />
              </button>
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <div>
      <div className="mt-[60px]"></div>
      <div>
        <PageHeaderV2 titlename={"ตั้งค่าโรงพยาบาล"} />
        <TableSearchV1
          columns={columns}
          data={dataHospital}
          filters={filters}
          setFilters={setFilters}
          loading={isLoading}
          total={total}
          page={page}
          maxPage={totalPage}
          setPage={setPage}
          sortBy={sortBy}
          onSortChange={handleSortChange}
          addData={{
            name: "เพิ่มโรงพยาบาล",
            url: "/admin/hospitalsetting/add-hospital",
          }}
          noDataComponent={<div className="w-full text-left">ไม่พบข้อมูล</div>}
        />
      </div>
    </div>
  );
}
export default HospitalSetting;
